import getVWKey from "../helpers/getVWKey";
import Utils from "../utils";
import RenderManager from "../rendering/render-manager";
import Transition from "./Transition";

class Base2DElement {
    _initDefaultVars() {
        this._type = "2DObject";
        this._is2DObject = true;
        this._isMounted = false;
        this._getVWSize = getVWKey;
        this._needsUpdate = true;
        this._disabled = false;

        this._hiddenMobile = false;
        this._hiddenDesktop = false;

        this._options = null;
        this._uuid = null;
        this._parentLayer = null;
        this._index = null;
        this._xy = new THREE.Vector2();
        this._wh = new THREE.Vector2();
        this._clones = new Map();

        this._disableEvents = false;

        this._sizeSm = null;
        this._sizeLg = null;
    }

    static Namespace = "http://www.w3.org/2000/svg"; //DevSkim: ignore DS137138

    get type() { return this._type; }
    set type(val) { this._type = val; }

    get type2d() { return this._type2d; }
    set type2d(val) { this._type2d = val; }

    get is2DObject() { return this._is2DObject; }
    get getVWSize() { return this._getVWSize; }

    get sizeSm() { return this._sizeSm; }
    get sizeLg() { return this._sizeLg; }
    set sizeLg(val) { this._sizeLg = val; }
    set sizeSm(val) { this._sizeSm = val; }

    get hiddenMobile() { return this._hiddenMobile; }
    set hiddenMobile(val) { this._hiddenMobile = val; }
    get hiddenTablet() { return this._hiddenTablet; }
    set hiddenTablet(val) { this._hiddenTablet = val; }
    get hiddenDesktop() { return this._hiddenDesktop; }
    set hiddenDesktop(val) { this._hiddenDesktop = val; }

    get isMounted() { return this._isMounted; }
    set isMounted(val) { this._isMounted = val; }
    get needsUpdate() { return this._needsUpdate; }
    set needsUpdate(val) { this._needsUpdate = val; RenderManager.activeCamera.update = true; }
    get disabled() { return this._disabled; }
    set disabled(val) { this._disabled = val; }
    get uuid() { return this._uuid; }
    set uuid(val) { this._uuid = val; }
    get parentLayer() { return this._parentLayer; }
    set parentLayer(val) { this._parentLayer = val; }
    get index() { return this._index; }
    set index(val) { this._index = val; }
    get options() { return this._options; }
    set options(val) { this._options = val; }

    get disableEvents() { return this._disableEvents; }
    set disableEvents(val) { this._disableEvents = val; }

    get x() { return this._xy.x; }
    set x(val) { this._xy.x = val; }
    get y() { return this._xy.y; }
    set y(val) { this._xy.y = val; }

    get width() { return this._wh.x; }
    set width(val) { this._wh.x = val; }
    get height() { return this._wh.y; }
    set height(val) { this._wh.y = val; }

    get inLetterbox() { return this._inLetterbox && !Q3.QuizManager.quizCompactLayout; }
    set inLetterbox(val) { this._inLetterbox = val; }

    get supportsActions() { return false; }
    get disableContext() { return false; }

    get absoluteBounds() {
        const { width, height } = RenderManager.getSize();

        return {
            x: this.x * width,
            y: this.y * height,
            w: this.width * width,
            h: this.height * height
        };
    }

    get data() {
        const layer = Q3.data.layers.layers2D[this.parentLayer.uuid];

        return layer ? layer.objects[this.uuid] : {};
    }

    get clickElement() {
        return this.domElement;
    }
    get elementToClone() {
        return this.domElement;
    }

    get highLightElement() {
        return this.domElement
    }

    get hasClickActions() {
        if (Q3.editMode) return true;
        return Boolean(this.data && this.data.action && this.data.action.filter(a => a && a.userAction === "click").length)
    }

    get domElement() { return this._domElement; }
    set domElement(val) { this._domElement = val; }


    selectHandler(e) {
        if (!Q3.editMode || Q3.isSelecting2dObject) return;
        if ((e.ctrlKey || e.metaKey) && Q3.selected && Q3.selected.multiSelectable) {
            if (Q3.selected.target) {
                return;
            }
            Q3.multiSelect[Q3.selected.uuid] = Q3.selected;
            Q3.multiSelect[this.uuid] = this;
            Q3.Events.fire('selectchange');
        } else {
            Q3.multiSelect = {};
            Q3.selected = this;
            Q3.Events.fire('selectchange');
            RenderManager.activeCamera.update = true;
        }
    }

    createRemoveEl(onClick, el) {
        el = el || this.clickElement;
        let removeFromQuiz = document.createElement("div");
        removeFromQuiz.addEventListener("click", onClick);
        removeFromQuiz.className = 'remove-from-quiz';
        // removeFromQuiz.style.display = 'none';
        let remVal = parseFloat(document.documentElement.style.fontSize);
        let left = (el.offsetWidth + el.offsetLeft)/remVal + "rem"
        let top = (el.offsetTop)/remVal + "rem"

        Object.assign(removeFromQuiz.style, {left: left, top: top})
        el.parentNode.appendChild(removeFromQuiz);
        this.removeFromQuiz = this.removeFromQuiz || new Map();
        if (el === this.clickElement) {
            this.removeFromQuiz.set(el, removeFromQuiz);
        }

    }

    setRemoveElPosition(el) {
        let removeEl = this.removeFromQuiz.get(el);
        let remVal = parseFloat(document.documentElement.style.fontSize);
        let left = (el.offsetWidth + el.offsetLeft)/remVal + "rem"
        let top = (el.offsetTop)/remVal + "rem";
        Object.assign(removeEl.style, {left: left, top: top})
    }


    destroyRemoveEl(el) {
        if (el) {
            let remover = this.removeFromQuiz.get(el);
            if (remover) {
                remover.remove();
            }
        }
    }

    getRenderPositionAndSize(width, height) {
        const size = RenderManager.getSize();

        if (!width) { width = size.width; }
        if (!height) { height = size.height; }

        if (!Q3.editMode && this.inLetterbox !== false) {
            width = Q3.letterbox.offsetWidth / RenderManager.pixelRatio;
            height = (Q3.letterbox.offsetHeight) / RenderManager.pixelRatio;
        }

        let w = this.width * width * RenderManager.pixelRatio;
        let h = this.height * height * RenderManager.pixelRatio;

        const [x, y] = this._calcPosition(width, height);

        return { x, y, w, h };
    }
    _calcPosition(width, height) {
        let y, x;

        x = this.x * width * RenderManager.pixelRatio;
        y = this.y * height * RenderManager.pixelRatio;

        return [x, y];
    }
    checkPosition(pos) {
        return (pos.x > this.x &&
            pos.x < this.x + this.width &&
            pos.y > this.y &&
            pos.y < this.y + this.height);
    }

    _initViewerActions() {
        const action = this.data.action;

        if (action) {
            action.forEach(currAction => {
                //define a transition
                const transition = new Transition(currAction.systemAction, currAction.value, this);
                if (currAction.userAction === "click") {
                    this.domElement.addEventListener('click', (e) => {
                        transition.click();
                        if (currAction.systemAction === "playpause" && this.type2d === "Button") {
                            this.setPlayPauseButtonStyle();
                        }
                    }, false);
                }
            });
        }
    }

    constructor(options = {}, parentLayer, uuid = THREE.Math.generateUUID()) {
        // Javascript calls top level variable definitions before prototype constructor, so any variables that had their values set before it will be reset to their default values
        this._initDefaultVars();

        this._options = options;
        this._uuid = uuid;
        this._parentLayer = parentLayer;
        this._index = options.index;
        this._inLetterbox = Boolean(options.inLetterbox !== false);
        this._xy.x = "x" in options ? options.x : this._xy.x;
        this._xy.y = "y" in options ? options.y : this._xy.y;
        this._wh.x = "width" in options ? options.width : this._wh.x;
        this._wh.y = "height" in options ? options.height : this._wh.y;
        this._hiddenMobile = "hiddenMobile" in options ? options.hiddenMobile : this._hiddenMobile;
        this._hiddenTablet = "hiddenTablet" in options ? options.hiddenTablet : this._hiddenTablet;
        this._hiddenDesktop = "hiddenDesktop" in options ? options.hiddenDesktop : this._hiddenDesktop;
        this._disableEvents = "disableEvents" in options ? Boolean(options.disableEvents) : this._disableEvents;
        this.customCursor = "customCursor" in options ? Q3.s3Url + options.customCursor : '';

        const initialData = {
            x: this._xy.x, y: this._xy.y,
            width: this._wh.x, height: this._wh.y,
        };

        this._sizeSm = JSON.parse(JSON.stringify("sizeSm" in options ? options.sizeSm : initialData));
        this._sizeLg = JSON.parse(JSON.stringify("sizeLg" in options ? options.sizeLg : initialData));

        this._initValues(options);
        this.domElement = this._createContainer();
        if (this.disableEvents && !Q3.editMode) {
            this.domElement.style.pointerEvents = "none";
        }
        this.domElement.id = this.uuid;
        this.domElement.setAttribute("type-2d", this.type2d);

        this.parentLayer.domElement.appendChild(this.domElement);

        if (this.customCursor) {
            this.domElement.classList.add('custom-cursor')
            this.domElement.style.cursor = `url(${this.customCursor}), auto`
        } else {
            this.domElement.style.cursor = this.hasClickActions ? "pointer" : "default";
        }

        if (!Q3.editMode && this.supportsActions) { this._initViewerActions(); }
        this.openContext = this.openContext.bind(this);
        if (Q3.editMode && this.type2d !== "MathFormula") {
            this.domElement.addEventListener("mouseover", () => {
                this.clickElement.classList.add("mouseover-2d");
            });
            this.domElement.addEventListener("mouseout", () => {
                this.clickElement.classList.remove("mouseover-2d");
            })
        }
        if (Q3.editMode && !this.disableContext) {
            let element = this.domElement;
            element.addEventListener("mouseup", this.openContext);
        }
        if (Q3.editMode
          && options.animation
          && options.animation.duration
          && options.animation.name
          && options.animation.name !== "none" ) {
            this.parentLayer.domElement.style.animationFillMode = "both";
            this.parentLayer.domElement.style.animationDelay = this.parentLayer.editorAnimationDelay + "s";
            this.parentLayer.domElement.style.animationDuration = options.animation.duration + "s";
            this.parentLayer.domElement.style.animationName = options.animation.name;
        }
    }

    addMouseOverListeners(element) {
        if (Q3.editMode) {
            element.addEventListener("mouseover", () => {
                element.classList.add("mouseover-2d");
            });
            element.addEventListener("mouseout", () => {
                element.classList.remove("mouseover-2d");
            })
        }
    }

    openContext(e, opts) {
        if (e.which !== 3 || (!this.domElement.contains(e.target) && !opts.fromResizer) || this.disableContext) return;
        const crd = Q3.getRelativeCoordinates(e, document.getElementById('app'));
        Q3.Events.fire("context-2d", { x: crd.x, y: crd.y, uuid: this.parentLayer.uuid, type2d: this.type2d })
    }

    _initValues(options) { implementationMissing(); }
    _createContainer() {
        const container = document.createElement('div');

        if (!Q3.editMode) {
            if (this.hiddenMobile) { container.classList.add("hidden-mobile"); }
            if (this.hiddenDesktop) { container.classList.add("hidden-desktop"); }
        }

        return container;
    }

    redraw(width, height) { implementationMissing(); }
    hide() { implementationMissing(); }
    show() { implementationMissing(); }
    delete() { implementationMissing(); }
    clone() { implementationMissing(); }

    get multiSelectable() { return true; }

    _draw(width, height) { this.redraw(width, height); }

    render(width, height) {
        if ((!Q3.data.layers.layers2D[this.parentLayer.uuid] && !this.parentLayer.isTemporary)
            || this.disabled
            || Utils.queryParams.has("disable_2d"))
            return;

        if (this.needsUpdate) {
            this._draw(width, height);

            if (width > 0 && height > 0) this.needsUpdate = false;
        }
    }

};

export default Base2DElement;
export { Base2DElement };

function implementationMissing() { throw new Error("Not implemented exception.") }